import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-expiration-banner',
  templateUrl: './expiration-banner.component.html',
  styleUrls: ['./expiration-banner.component.css'],
})
export class ExpirationBannerComponent {
  @Input() type: 'warning' | 'danger' | 'custom';
  @Input() expirationDate: string;
  @Output() closeAlert: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}

  closeBanner() {
    this.closeAlert.emit();
  }
}
